module.exports = __webpack_public_path__ + "static/media/img125_R.a630782b.jpg";